import React from 'react'
import Odometer from 'react-odometerjs'
import '../../stylesheets/odometer-theme-default.css'

let ControllerOdometer = ({children, value, units, colorClass, valueClass, dark, pulse}) =>
    <div className={"row col-12 p-0 justify-content-between m-1 bg-dark rounded alarm-container " + (dark ? "text-dark " : "text-white ") + (pulse ? "pulse " : "")}>
        <div className={"d-inline-block col-5 pt-2 pb-2 pl-3 pr-1 pr-sm-2 text-left ellipsize " + colorClass} >
            {children}
        </div>
        <div className={"d-inline-block col-auto pt-2 pb-2 pl-1 pr-1 pr-xl-2 pl-xl-2 " + valueClass}>
            <Odometer value={value || 0} format="(,ddd).dd" />
        </div>
        <div className={"d-inline-block col-2 pt-2 pb-2 pl-1 pr-2 pl-sm-2 " + colorClass} >
            {units}
        </div>
    </div>

export default ControllerOdometer


// WEBPACK FOOTER //
// ./src/components/ui/ControllerOdometer.js